import React from 'react';
import { Card, Typography } from 'antd';

const { Title, Paragraph, Text } = Typography;

function TermsOfService() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 20px' }}>
      
      <Card style={{ padding: '40px' }}>
        <Title level={1} style={{ textAlign: 'center', marginBottom: '40px' }}>
          Terms of Service
        </Title>
        
        <Title level={3}>Effective Date: March 30, 2026</Title>
        
        <Paragraph>
          <Text strong>Pathmarkr</Text> ("we," "our," or "us") provides route-based advertising and fleet intelligence services through our platform and mobile applications. These Terms of Service ("Terms") govern your use of our services.
        </Paragraph>

        <Title level={2}>1. Acceptance of Terms</Title>
        <Paragraph>
          By accessing or using Pathmarkr's services, you agree to be bound by these Terms. If you do not agree to these Terms, you may not use our services.
        </Paragraph>

        <Title level={2}>2. Services</Title>
        <Paragraph>
          Pathmarkr provides:
        </Paragraph>
        <ul>
          <li>Route-based advertising campaign management</li>
          <li>Fleet tracking and analytics integration with Geotab</li>
          <li>Proximity marketing and customer engagement tools</li>
          <li>SMS notifications and communication services</li>
          <li>Performance analytics and reporting</li>
        </ul>

        <Title level={2}>3. Account Registration</Title>
        <Paragraph>
          To use our services, you must:
        </Paragraph>
        <ul>
          <li>Be at least 18 years old</li>
          <li>Provide accurate, complete information</li>
          <li>Maintain the security of your account credentials</li>
          <li>Provide valid Geotab account information for fleet integration</li>
        </ul>

        <Title level={2}>4. SMS Messaging Terms</Title>
        <Paragraph>
          By providing your phone number and consenting to SMS messaging:
        </Paragraph>
        <ul>
          <li>You agree to receive automated text messages from Pathmarkr</li>
          <li>Message frequency varies based on service usage</li>
          <li>Standard message and data rates may apply</li>
          <li>You can opt-out at any time by replying "STOP"</li>
          <li>You can get help by replying "HELP"</li>
        </ul>
        
        <Paragraph>
          <Text strong>Opt-in Methods:</Text> You can consent to receive SMS messages by (1) checking the consent box during registration, (2) texting "START" to our SMS number, or (3) verbally agreeing during a phone call with our representatives.
        </Paragraph>

        <Title level={2}>5. User Responsibilities</Title>
        <Paragraph>
          You agree to:
        </Paragraph>
        <ul>
          <li>Use our services only for lawful purposes</li>
          <li>Not interfere with or disrupt our services</li>
          <li>Not attempt to gain unauthorized access to our systems</li>
          <li>Provide accurate Geotab credentials for integration</li>
          <li>Comply with all applicable laws and regulations</li>
        </ul>

        <Title level={2}>6. Payment Terms</Title>
        <Paragraph>
          <Text strong>Subscription Fees:</Text> Pathmarkr offers various subscription plans with different features and pricing. Fees are billed monthly or annually as selected.
        </Paragraph>
        
        <Paragraph>
          <Text strong>Payment Method:</Text> You must provide valid payment information. You authorize us to charge your selected payment method for the subscription fees.
        </Paragraph>
        
        <Paragraph>
          <Text strong>Refunds:</Text> Refunds are handled on a case-by-case basis. Please contact our support team for refund requests.
        </Paragraph>

        <Title level={2}>7. Data and Privacy</Title>
        <Paragraph>
          Your privacy is important to us. Our collection and use of your information is governed by our Privacy Policy, which is incorporated into these Terms by reference.
        </Paragraph>
        
        <Paragraph>
          <Text strong>SMS Consent:</Text> We do not sell or share your phone number with third parties for their own marketing purposes. Your SMS consent is maintained securely and you can opt-out at any time.
        </Paragraph>

        <Title level={2}>8. Intellectual Property</Title>
        <Paragraph>
          All content, features, and functionality of the Pathmarkr platform are owned by Pathmarkr and are protected by copyright, trademark, and other intellectual property laws.
        </Paragraph>

        <Title level={2}>9. Service Availability</Title>
        <Paragraph>
          We strive to maintain high service availability but cannot guarantee 100% uptime. We may temporarily suspend services for maintenance, updates, or other operational reasons.
        </Paragraph>

        <Title level={2}>10. Termination</Title>
        <Paragraph>
          We may terminate or suspend your account if you:
        </Paragraph>
        <ul>
          <li>Violate these Terms of Service</li>
          <li>Engage in fraudulent or illegal activities</li>
          <li>Fail to pay subscription fees</li>
          <li>Compromise the security of our platform</li>
        </ul>

        <Title level={2}>11. Disclaimer of Warranties</Title>
        <Paragraph>
          Our services are provided "as is" without warranties of any kind, either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.
        </Paragraph>

        <Title level={2}>12. Limitation of Liability</Title>
        <Paragraph>
          In no event shall Pathmarkr be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
        </Paragraph>

        <Title level={2}>13. Governing Law</Title>
        <Paragraph>
          These Terms shall be governed by and construed in accordance with the laws of [Your Jurisdiction], without regard to its conflict of law provisions.
        </Paragraph>

        <Title level={2}>14. Changes to Terms</Title>
        <Paragraph>
          We reserve the right to modify these Terms at any time. We will notify you of any changes by posting the updated Terms on our website and updating the "Effective Date" above.
        </Paragraph>

        <Title level={2}>15. Contact Information</Title>
        <Paragraph>
          If you have questions about these Terms, please contact us:
        </Paragraph>
        <ul>
          <li>Email: legal@pathmarkr.com</li>
          <li>Phone: [Your Phone Number]</li>
          <li>Address: [Your Business Address]</li>
        </ul>

        <Paragraph style={{ marginTop: '40px', textAlign: 'center', color: '#666' }}>
          <Text italic>Last updated: March 30, 2026</Text>
        </Paragraph>
      </Card>
    </div>
  );
}

export default TermsOfService;
